const BookingType = {
    SALES_CONSULTATION: 'SALES_CONSULTATION',
    SHOWROOM_VISIT: 'SHOWROOM_VISIT',
};
const BookingStatus = {
    PENDING: 'PENDING',
    CONFIRMED: 'CONFIRMED',
    CANCELLED: 'CANCELLED',
};
const BookingSourceType = {
    SERVICING_OPPORTUNITY: 'SERVICING_OPPORTUNITY',
    CONVERSATION: 'CONVERSATION',
};
const AttendeeCollectionName = {
    ServicesProviders: 'ServicesProviders',
    Leads: 'Leads',
    Buyers: 'Buyers',
};

export { AttendeeCollectionName, BookingSourceType, BookingStatus, BookingType };
//# sourceMappingURL=Booking.js.map
